import { render } from "./main-menu.vue?vue&type=template&id=ad6c884c&scoped=true&ts=true"
import script from "./main-menu.vue?vue&type=script&lang=ts"
export * from "./main-menu.vue?vue&type=script&lang=ts"

import "./main-menu.vue?vue&type=style&index=0&id=ad6c884c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6c884c"]])

export default __exports__